<h1 mat-dialog-title *ngIf="data.title">{{data.title}}</h1>
<div mat-dialog-content>{{data.content}}</div>
<div mat-dialog-actions class="justify-content-end">
  <button  mat-button mat-dialog-close>Ok</button>
</div>
